import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

let cmslUrl = window.location.origin;

export const OidcConfigCMS: UserManagerSettings = {
  client_id: "S5E-CMS-PKCE",
  redirect_uri: `${cmslUrl}/auth/callback`,
  authority: "/authority",
  response_type: "code",
  post_logout_redirect_uri: `${cmslUrl}`,
  scope:
    "openid profile email graphql-gateway master-data communication personal-data reporting offline_access",
  silent_redirect_uri: `${cmslUrl}/auth/silent_callback`,
  automaticSilentRenew: true,
  loadUserInfo: true,
  userStore: new WebStorageStateStore({ store: localStorage }),
  prompt: "login",
};
